var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, EventEmitter } from '@angular/core';
import { Select } from '@ngxs/store';
import { OrganizationsState } from '../../state/organizations.state';
import { Observable } from 'rxjs';
var CollectionPickerComponent = /** @class */ (function () {
    function CollectionPickerComponent() {
        this.selectionLabel = '';
        this.privateSelected = new EventEmitter();
        this.organizationSelected = new EventEmitter();
        this.collectionSelected = new EventEmitter();
    }
    CollectionPickerComponent.prototype.ngOnInit = function () {
    };
    CollectionPickerComponent.prototype.handleClickPrivate = function () {
        this.privateSelected.emit();
    };
    CollectionPickerComponent.prototype.handleClickOrganization = function (organzation) {
        this.organizationSelected.emit(organzation);
    };
    CollectionPickerComponent.prototype.handleClickCollection = function (collection) {
        this.collectionSelected.emit(collection);
    };
    __decorate([
        Select(OrganizationsState.getOrganization),
        __metadata("design:type", Observable)
    ], CollectionPickerComponent.prototype, "organization$", void 0);
    __decorate([
        Select(OrganizationsState.getCollections),
        __metadata("design:type", Observable)
    ], CollectionPickerComponent.prototype, "collections$", void 0);
    return CollectionPickerComponent;
}());
export { CollectionPickerComponent };
